module.exports = __webpack_public_path__ + "img/solution_partner_yq@2x.51582360.png";